import loadable from "@loadable/component"
import { render } from "storyblok-rich-text-react-renderer"
import Condition from "@mkt/ui/components/common/Condition"
import * as S from "../Content/styles"

//#region Dynamic import components
const CTAs = loadable(() => import("../Content/CTAs"))
const CardDetails = loadable(() => import("../Content/CardDetails"))
const Benefits = loadable(() => import("../Content/Benefits"))
const Faq = loadable(() => import("../Content/Faq"))

//#endregion

const FormDefault = ({ content, setFormFocused, children }) => {
  const {
    product_ctas: ctas,
    product_benefits: benefits,
    product_faq: faq,
    disclaimer,
  } = content

  return (
    <div>
      <div css={S.hold}>
        <div css={S.content}>
          <CardDetails content={content} />
          <CTAs blok={ctas} setFormFocused={setFormFocused} />
          <Condition condition={benefits?.length > 0}>
            <Benefits blok={benefits[0]} />
          </Condition>
          <Condition condition={!!disclaimer}>
            <div css={S.disclaimer}>{render(disclaimer)}</div>
          </Condition>
        </div>
        <div css={S.aside}>
          <div css={S.form} data-form>
            {children}
          </div>
        </div>
      </div>
      <Condition condition={faq?.length > 0}>
        <div css={S.faq}>
          <div css={S.faqHold}>
            <Faq blok={faq[0]} />
          </div>
        </div>
      </Condition>
    </div>
  )
}

export default FormDefault
